// extracted by mini-css-extract-plugin
module.exports = {"countdown-wrapper":"_1LHM8","count-block":"_2lACD"};